import React, { useState, useLayoutEffect } from 'react';
import axios from 'axios';
// @mui
import { Grid, Button, Container, Stack, Typography, CssBaseline } from '@mui/material';
import { styled } from '@mui/material/styles';

// components

// ----------------------------------------------------------------------

const StyledSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  '& h3': {
    paddingBottom: '10px',
  },
}));

const StyledDate = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '10px',
  paddingBottom: '20px',
  borderBottom: '2px solid #111',
});

const BoardContent = styled('div')({
  padding: '40px 20px',
  borderBottom: '1px solid #ddd',
  minHeight: '320px',
  marginBottom: '40px',
});

// ----------------------------------------------------------------------

export default function ViewPost({ data, closeViewPost }) {
  // console.log('data', data)

  // ----------------------------------------------------------------------
  function sendCancel() {
    closeViewPost();
  }
  const [boardContent, setBoardContent] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SERVER_URL}/boards/detail/${data}`,
        method: 'get',
      });

      console.log('data', response.data[0][0]);
      setBoardContent(response.data[0][0]);
    } catch (error) {
      console.log('error', error);
    }
  };

  useLayoutEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <CssBaseline />
      <div style={{ padding: '60px 10%' }}>
        <StyledSection>
          <h3>{boardContent.content_title} </h3>
          <StyledDate>
            <p>{boardContent.company_name}</p>
            <p>{boardContent.created_at}</p>
          </StyledDate>
          <BoardContent dangerouslySetInnerHTML={{ __html: boardContent.content_message }}>
            {/* {boardContent.content_message} */}
          </BoardContent>
        </StyledSection>
        <Button
          variant="contained"
          onClick={() => {
            sendCancel();
          }}
        >
          목록
        </Button>
      </div>
    </>
  );
}
